import { CurrenciesCrypto, CurrenciesFiat, Currencies } from '@sparling/financial-common'

const crypto = []
const cryptoTrustology = []
const fiat = []
const currencies = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item in CurrenciesCrypto) {
  crypto.push({
    value: item,
    label: item,
  })
}

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item in CurrenciesCrypto) {
  if (!['USDT', 'USDC'].includes(item)) {
    cryptoTrustology.push({
      value: item,
      label: item,
    })
  }
}

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item in CurrenciesFiat) {
  fiat.push({
    value: item,
    label: item,
  })
}

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item in Currencies) {
  currencies.push({
    value: item,
    label: item,
  })
}

export const CURRENCIES = currencies

export const CURRENCIES_CRYPTO = crypto

export const CURRENCIES_CRYPTO_TRUSTOLOGY = cryptoTrustology

export const CURRENCIES_FIAT = fiat

export const isCurrenciesCrypto = (currency: string): boolean => {
  return currency in CurrenciesCrypto
}

export const isCurrenciesFiat = (currency: string): boolean => {
  return currency in CurrenciesFiat
}

export const currencyCryptoOrFiat = (currency: string | undefined): string => {
  if (!currency) return ''
  if (isCurrenciesCrypto(currency)) {
    return 'crypto'
  }
  if (isCurrenciesFiat(currency)) {
    return 'fiat'
  }
  // eslint-disable-next-line
  console.error('no such currency exists')
  return ''
}
